import { ElMessage } from "element-plus";
import { openTutorConfirm } from "@/composables/tutorConfirm";

/**
 * Replaces legacy this.$root.$confirm / $alert
 * Uses TutorConfirmDialog (图1 style) instead of Element Plus MessageBox.
 */
export function useConfirm() {
  /**
   * @param {string} message
   * @param {object} [options]
   * @returns {Promise} resolves on confirm; rejects on cancel (EP-compatible)
   */
  function confirm(message, options = {}) {
    const {
      confirmButtonText = "Confirm",
      cancelButtonText = "Cancel",
      type = "error",
      showCancelButton = true,
      awaitSubmit = false,
      width = 420,
      icon = { default: true },
      rejectOnCancel = true,
    } = options;

    return openTutorConfirm(message, type, {
      awaitSubmit,
      width,
      icon,
      cancelBtn: {
        display: showCancelButton,
        text: cancelButtonText,
      },
      confirmBtn: {
        display: true,
        text: confirmButtonText,
      },
    }).then((result) => {
      const ok = result === true || result?.result === true;
      if (!ok) {
        if (rejectOnCancel) return Promise.reject("cancel");
        return false;
      }
      return result;
    });
  }

  /**
   * Legacy $root.$alert / $alertTips
   * Default: no Cancel, icon.default=false (type success/error icons), Confirm button.
   */
  function alert(message, options = {}) {
    const { icon, ...rest } = options;
    return confirm(message, {
      type: options.type || "error",
      icon: { default: false, ...(icon || {}) },
      ...rest,
      showCancelButton: false,
      confirmButtonText: options.confirmButtonText || "Confirm",
      rejectOnCancel: options.rejectOnCancel ?? false,
    });
  }

  return { confirm, alert };
}

/**
 * Replaces legacy this.$root.$snackbar
 */
export function useSnackbar() {
  function show(message, option = {}) {
    ElMessage({
      message,
      type: option.type || "info",
      duration: option.duration ?? 4000,
      showClose: option.showClose ?? false,
    });
  }
  return { show };
}
